import React from "react";
import {CircularProgress, Paper, Typography,} from "@material-ui/core";
import {Alert} from '@material-ui/lab';
import useStyles from '../styles/styles';
import {useQuery} from "@apollo/react-hooks";
import {gql} from "apollo-boost";
import ServicersTable from '../components/Servicers/ServicersTable';
import {ActiveState} from "../utils/ActiveState";

const Servicers = () => {
    const classes = useStyles();
    const {loading, error, data, refetch} = useQuery(gql`
        query AllServicers {
            allServicer {
                nodes {
                    id
                    active
                    email
                    name
                    phone
                    website
                    choiceOfLaw
                    brandingContactInformation {
                        name
                        email
                        phone
                        website
                    }
                }
                totalCount
            }
            allVendorPause {
                totalCount
                nodes {
                    id
                    campaign
                    portfolio
                    servicer
                    expiration
                    startDate
                }
            }
        }
    `, {
        notifyOnNetworkStatusChange: true,
    });

    const getData = (allServicers, allVendorPauses) => {
        return allServicers.map(servicer => {
            const servicerId = servicer.id

            const vendorPause = allVendorPauses.find(vendorPause => {
                const matchesAnyCampaign = vendorPause.campaign === '*'
                const matchesAnyPortfolio = vendorPause.portfolio === '*'
                const matchesServicer = vendorPause.servicer === servicerId
                const isActive = vendorPause.startDate != null ? (new Date(vendorPause.startDate)).getTime() < Date.now() : true

                return matchesAnyCampaign && matchesAnyPortfolio && matchesServicer && isActive
            }) || null

            if(vendorPause && servicer.active){
                servicer.activeState = ActiveState.PAUSED
            }else{
                servicer.activeState = servicer.active ? ActiveState.ACTIVE : ActiveState.INACTIVE
            }

            return servicer
        })
    }

    return (
        <>
            <Typography variant="h2">
                Servicers
            </Typography>
            {!loading && error ? (
                <Paper className={classes.paper}>
                    <Alert severity="error">There is an error!</Alert>
                    <pre>{JSON.stringify(error, null, 2)}</pre>
                </Paper>
            ) : null}
            {loading ? (
                <Paper className={classes.paper}>
                    <div className={classes.loadingBar}>
                        <CircularProgress
                            size={50}
                            thickness={4}
                        />
                    </div>
                </Paper>
            ) : null}
            {!loading && data && data.allServicer.nodes ? (
               <ServicersTable
                   data={getData(data.allServicer.nodes, data.allVendorPause.nodes)}
                   refetch={refetch}
               />
            ) : null}
        </>
    )
};


export default Servicers;
